var _defs, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgElectorate = function SvgElectorate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".electorate_svg__a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.178 5.588c0 2.332-3.506 6.929-4.7 8.424a.5.5 0 0 1-.783 0C10.506 12.516 7 7.92 7 5.588a5.089 5.089 0 0 1 10.178 0",
    className: "electorate_svg__a"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 5.588a1.908 1.908 0 1 1-1.91-1.908A1.91 1.91 0 0 1 14 5.588",
    className: "electorate_svg__a"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.06 4.5h2.04a1 1 0 0 1 .994.895l1.79 17a1 1 0 0 1-1 1.105H3.111a1 1 0 0 1-1-1.105l1.79-17A1 1 0 0 1 4.9 4.5h2.217M2.632 17.5h18.736M15.029 10.5h5.603M3.368 10.5h5.781M7 23.5l.972-15M17.178 23.5l-.971-15",
    className: "electorate_svg__a"
  })));
};
export default SvgElectorate;